var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5885 6.66892L18.9284 5.52349C18.37 4.55428 17.1324 4.21992 16.1619 4.77604V4.77604C15.6999 5.04819 15.1486 5.12541 14.6296 4.99066C14.1107 4.8559 13.6666 4.52025 13.3954 4.05772C13.2209 3.76373 13.1271 3.42887 13.1236 3.08702V3.08702C13.1393 2.53893 12.9325 2.00782 12.5503 1.61466C12.1682 1.2215 11.6431 0.999774 11.0948 1H9.76492C9.22775 0.999994 8.71272 1.21405 8.33379 1.5948C7.95486 1.97555 7.74328 2.4916 7.74586 3.02877V3.02877C7.72994 4.13785 6.82627 5.02854 5.71708 5.02843C5.37523 5.02488 5.04037 4.93112 4.74638 4.75663V4.75663C3.77584 4.20051 2.5383 4.53486 1.97987 5.50407L1.27126 6.66892C0.713503 7.63692 1.04331 8.87368 2.00899 9.43543V9.43543C2.6367 9.79783 3.02339 10.4676 3.02339 11.1924C3.02339 11.9172 2.6367 12.587 2.00899 12.9494V12.9494C1.04453 13.5073 0.714369 14.7411 1.27126 15.7062V15.7062L1.94104 16.8613C2.20269 17.3334 2.64169 17.6818 3.1609 17.8294C3.6801 17.977 4.23671 17.9115 4.70755 17.6476V17.6476C5.17041 17.3775 5.72199 17.3035 6.23967 17.442C6.75735 17.5806 7.19825 17.9202 7.46435 18.3853C7.63884 18.6793 7.7326 19.0142 7.73615 19.356V19.356C7.73615 20.4765 8.64446 21.3848 9.76492 21.3848H11.0948C12.2115 21.3848 13.1182 20.4824 13.1236 19.3657V19.3657C13.121 18.8269 13.3339 18.3093 13.7149 17.9283C14.0959 17.5473 14.6135 17.3344 15.1523 17.337C15.4934 17.3461 15.8269 17.4395 16.123 17.6088V17.6088C17.091 18.1665 18.3278 17.8367 18.8896 16.871V16.871L19.5885 15.7062C19.859 15.2418 19.9332 14.6888 19.7948 14.1695C19.6563 13.6503 19.3165 13.2077 18.8507 12.9397V12.9397C18.3849 12.6717 18.0451 12.2291 17.9067 11.7098C17.7682 11.1905 17.8425 10.6375 18.113 10.1732C18.2889 9.86602 18.5436 9.61135 18.8507 9.43543V9.43543C19.8106 8.87398 20.1397 7.64444 19.5885 6.67862V6.67862V6.66892Z",
    stroke: "#564ECE",
    strokeWidth: 1.59074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 10.4345,
    cy: 11.1926,
    r: 2.79563,
    stroke: "#564ECE",
    strokeWidth: 1.59074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsblue);
export default __webpack_public_path__ + "static/media/Settingsblue.6be5a1c54141364c51fa228570dc9617.svg";
export { ForwardRef as ReactComponent };